// extracted by mini-css-extract-plugin
module.exports = {"scrollAreaContainer":"tab_scrollAreaContainer__VhBnx"};